import { render, staticRenderFns } from "./PmtaConfigForm.vue?vue&type=template&id=60f637b6&scoped=true"
import script from "./PmtaConfigForm.vue?vue&type=script&lang=js"
export * from "./PmtaConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f637b6",
  null
  
)

export default component.exports